import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';
import './Account.css';

const AccountLayout = () => {
    const { logout, customer } = useCustomerAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    if (!customer) return null; // Or loading spinner, but AuthGuard should handle this

    return (
        <div className="account-container">
            <div className="account-sidebar">
                <div className="user-brief">
                    <div className="user-avatar">{customer.name ? customer.name[0].toUpperCase() : 'U'}</div>
                    <h3>{customer.name || 'Dear Customer'}</h3>
                    <p>{customer.email}</p>
                </div>
                <nav className="account-nav">
                    <NavLink to="/account" end className={({ isActive }) => isActive ? 'active' : ''}>
                        My Profile
                    </NavLink>
                    <NavLink to="/account/orders" className={({ isActive }) => isActive ? 'active' : ''}>
                        Orders
                    </NavLink>
                    <NavLink to="/account/addresses" className={({ isActive }) => isActive ? 'active' : ''}>
                        Addresses
                    </NavLink>
                    <button onClick={handleLogout} className="btn-logout">
                        Logout
                    </button>
                </nav>
            </div>
            <div className="account-content">
                <Outlet />
            </div>
        </div>
    );
};

export default AccountLayout;
